define('views/modules/calendar/nutrition/water/water-counter',[
    // Libs
    'underscore', 'backbone', 'mustache',
    // views
    'views/parts/form/sliderbar-counter',
    // templates
    'text!templates/modules/calendar/nutrition/water/water-counter.html'
], function(
    // Libs
    _, Backbone, Mustache,
    // views
    VSliderbarCounter,
    // templates
    TWaterCounter
) {

    var VWaterCounter = Backbone.View.extend({
        template: TWaterCounter,

        regions: {
            watercounter: "#water-counter"
        },

        initialize: function(opt) {
            this.options = opt;

            this.view = {
                watercounter: new VSliderbarCounter({
                    labels: false,
                    min: "0",
                    max: "12",
                    color: true,
                    model: this.model,
                    className: 'slider-water-counter slider-no-space slider-only',
                    attribute: "water"
                })
            };

            this.listenTo(this.model, "change:water", this.onModelChange);
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext(this.options)));
            this.generateZones()
                .assign(this.view.watercounter, this.zone.$watercounter);

            this.setCounterNumber(this.getValue());

            return this;
        },

        getValue: function() {
            return this.view.watercounter.getValue();
        },

        setCounterNumber: function(value) {
            var percent = value / this.view.watercounter.options.max * 100;
            this.$el.find('.counter-number').html(value);
            this.$el.find('.water').css('height', percent + "%");
        },

        onModelChange: function(model, value, options) {
            this.setCounterNumber(value);
        }

    });

    return VWaterCounter;
});

